const getTimeStamp = (travelDepartureYear, travelDepartureMonth, travelDepartureDay) => {
  let depDate;
  let timeStamp;
  try {
    depDate = new Date(travelDepartureYear, travelDepartureMonth - 1, travelDepartureDay);
    timeStamp = depDate.getTime() / 1000;
  } catch (_e) {
    timeStamp = null;
  }
  return timeStamp;
};

export const logSearch = (loggingData, pageTypeURL) => {
  if (typeof exponea !== 'undefined') {
    exponea.track('search', {
      travel_adults: loggingData.numberOfAdults,
      travel_children: loggingData.numberOfChildren,
      travel_country_code: loggingData.countryCode,
      travel_departure_code: loggingData.departureCode,
      travel_departure_timestamp: getTimeStamp(
        loggingData.departureDateYear,
        loggingData.departureDateMonth,
        loggingData.departureDateDay,
      ),
      travel_destination_code: loggingData.destinationCode,
      travel_duration: loggingData.duration,
      page_type_url: pageTypeURL,
      travel_pax: loggingData.numberOfPassengers,
      travel_ages: loggingData.passengerAges,
      travel_type: loggingData.travelType,
    });
  }
};
